// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Link from '../_raw/ui/icon_link.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Link, {
  shouldSetDefaultSize: true,
  defaultWidth: 400,
  defaultHeight: 220,
});
